/**
 * 后端约定 selected_coupon_id 用 '0' 表示"无券"，前端需当作 falsy 处理。
 *
 * 该 helper 把这个约定收口到一处，避免散布在 PlanCard / PassCard / CreditsItem /
 * StripeConfirmDialog / Alipay 等多处独立判断。
 */
export const hasSelectedCoupon = (product: { selected_coupon_id?: string | null }): boolean => {
  const id = product.selected_coupon_id;
  return Boolean(id) && id !== '0';
};

/**
 * 把 selected_coupon_id 规整为 string | null（去除 '0' 占位）。
 * 用于 useState 初始化、CouponSelect 受控值等需要明确空值的场景。
 */
export const normalizeSelectedCouponId = (id: string | null | undefined): string | null => {
  return id && id !== '0' ? id : null;
};
